export default __webpack_public_path__ + "static/media/unicef-logo.dd47353a.png";